import React, { Component } from 'react'

import Layout from '../../components/Layout'
import CrudHeader from '../../components/CrudHeader'
import UserToolbar from '../../components/UserToolbar'
import EditModal from './EditModal'
import ListTable from './ListTable'
import { connect } from 'react-redux'
import { withStyles } from '@material-ui/core/styles'
import { preRegistrationsActions, searchTableActions } from '../../actions'
import { crudListStyle } from '../../styles'

class PreRegistrations extends Component {
  state = {
    modalOpen: false
  }

  componentWillUnmount() {
    const { resetState } = this.props
    resetState()
  }

  render() {
    const { modalOpen, openModal, closeModal, newPreRegistration, classes, token } = this.props
    return (
      <Layout toolBarRight={UserToolbar}>
        <CrudHeader
          title={'Pré-cadastros'}
          classes={classes}
          newResource={newPreRegistration}
          openModal={openModal}
          closeModal={closeModal}
          token={token}
          functionality={'conteudos'}
        />
        <ListTable />
        <EditModal open={modalOpen} onClose={closeModal} />
      </Layout>
    )
  }
}

const mapStateToProps = state => {
  return { modalOpen: state.preRegistrations.modalOpen, token: state.auth.token }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(preRegistrationsActions.openModal())
    },
    closeModal: () => {
      dispatch(preRegistrationsActions.closeModal())
    },
    newPreRegistration: preRegistration => {
      dispatch(preRegistrationsActions.newFormPreRegistration(preRegistration))
    },
    resetState: () => {
      dispatch(preRegistrationsActions.resetState())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(crudListStyle)(PreRegistrations))



// WEBPACK FOOTER //
// ./src/containers/PreRegistration/index.js